import { Card } from '@healthinal/ui';
import { SocialAnamnesisDto } from '../../../../../api/generated/model';
import { EditAnamnesisInstitutionForm } from './EditAnamnesisInstitutionForm.tsx';

export function AnamnesisInstitutionCard({
  social,
  patientId,
  anamnesisId,
}: {
  social: SocialAnamnesisDto;
  patientId: string;
  anamnesisId: string;
}) {
  return (
    <Card>
      <EditAnamnesisInstitutionForm
        key={anamnesisId}
        socialAnamnesis={social}
        patientId={patientId}
        anamnesisId={anamnesisId}
      />
    </Card>
  );
}
